
import { prop, Vue } from "vue-class-component";

class Props {
  fill = prop({ type: Boolean, default: true });
}
export default class Info extends Vue.with(Props) {}
